import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl  } from '@angular/forms';
import { AslibModalComponent } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponentService } from '../../services/base-component.service';

export function validarMaiorqueZero(control: AbstractControl) {
  const numero = control.value as number;
  if(numero <= 0) {
      return { numMenorqueZero: true };
  } else
  return null;
}
export function validarEmailPattern(control: AbstractControl) {
  const email = control.value as string;

  var emailRegex = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i;
  if(emailRegex.test(email)) {
      return { emailValido: true };
  } else
  return null;
}


@Component({
  selector: 'gpa-param-notificacao',
  templateUrl: './param-notificacao.component.html',
  providers: [BaseComponentService]
})
export class ParamNotificacaoComponent extends BaseComponentService implements OnInit {

  subscription: Subscription;

  parametroPagamentoList: any[];
  paramPagamentoForm: FormGroup;

  /*
   *  Controles do formulário
   */
  fcTimeMinutos: FormControl;
  fcDestinatario: FormControl;
  fcTituloEmail: FormControl;
  fcMensagem: FormControl;

  /*
   *   Variáveis relacionadas à validação do forrmulário com mensagem de erro de cada controle.
  */
  msgTimeMinutos: string;
  msgDestinatario: string;
  msgTituloEmail: string;
  msgMensagem: string;
 
  
  projetoIntegrado: string;
  ngOnInit() {

    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');
    this.criarControlesFormulario();
    this.criarFormulario();
    this.getParametrosPagamento(this.projetoIntegrado);
  }

  criarControlesFormulario() {
    this.fcTimeMinutos = new FormControl('', [Validators.required, validarMaiorqueZero,Validators.maxLength(280)]);
    this.fcDestinatario = new FormControl('', [Validators.required, Validators.email,Validators.maxLength(280), validarEmailPattern]);
    this.fcTituloEmail = new FormControl('', [Validators.required, Validators.maxLength(280)]);
    this.fcMensagem = new FormControl('', [Validators.required,Validators.maxLength(280)]);
  }



  criarFormulario() {
    this.paramPagamentoForm = new FormGroup({
      timeMinutos: this.fcTimeMinutos,
      destinatario: this.fcDestinatario,
      tituloEmail: this.fcTituloEmail,
      mensagem: this.fcMensagem
    });
  }

  atualizarFormulario(paramPagamento: any[]) {
    this.fcTimeMinutos.setValue(paramPagamento === null ? '' : paramPagamento.find(r=>r.idTipoParametro ===11).descricaoParametro);
    this.fcDestinatario.setValue(paramPagamento === null ? '' : paramPagamento.find(r=>r.idTipoParametro ===21).descricaoParametro);
    this.fcTituloEmail.setValue(paramPagamento === null ? '' : paramPagamento.find(r=>r.idTipoParametro ===22).descricaoParametro);
    this.fcMensagem.setValue(paramPagamento === null ? '' : paramPagamento.find(r=>r.idTipoParametro ===23).descricaoParametro);
  }

  /*
  * Limpa o formulário e desabilita os controles que dependam dos valores de outros.
  */
  limparOnClick() {
    this.atualizarFormulario(null);
  }

  salvarOnClick() {
    
    this.validarFormulario();
    if (this.paramPagamentoForm.invalid) {
      return;
    }

    this.parametroPagamentoList.find(r=>r.idTipoParametro ===11).descricaoParametro = this.fcTimeMinutos.value;
    this.parametroPagamentoList.find(r=>r.idTipoParametro ===21).descricaoParametro = this.fcDestinatario.value;
    this.parametroPagamentoList.find(r=>r.idTipoParametro ===22).descricaoParametro = this.fcTituloEmail.value;
    this.parametroPagamentoList.find(r=>r.idTipoParametro ===23).descricaoParametro = this.fcMensagem.value;
    

    this.save('/api/ProcessamentoArquivoRetorno', this.parametroPagamentoList, true, 'gpa');

  }

  /*
   * Valida os campos do formulário.
   */
  validarFormulario() {
    if (this.isCampoInvalido(this.fcTimeMinutos)) {
      this.msgTimeMinutos = 'Por favor, informe o Tempo de ocorrência do JOB.';
    }
    if (this.isCampoLen(this.fcTimeMinutos)) {
      this.msgTimeMinutos = 'Quantidade de caracteres informado inválido!';
    }
    if(this.fcTimeMinutos.getError('numMenorqueZero')){
      this.msgTimeMinutos = 'Por favor, o Tempo de ocorrência do JOB deve ser maior que zero, e numérico.';
    }
    if (this.isCampoInvalido(this.fcDestinatario)) {
      this.msgDestinatario = 'Por favor, informe o destinatário.';
    }
    if (this.isCampoLen(this.fcDestinatario)) {
      this.msgDestinatario = 'Quantidade de caracteres informado inválido!';
    }
    if (this.fcDestinatario.getError('email') || this.fcDestinatario.getError('emailValido')) {
      this.msgDestinatario = 'Por favor, informe um e-mail válido.';
    }

    if (this.isCampoInvalido(this.fcTituloEmail)) {
      this.msgTituloEmail = 'Por favor, informe o Título do e-mail.';
    }
    if (this.isCampoLen(this.fcTituloEmail)) {
      this.msgTituloEmail = 'Quantidade de caracteres informado inválido!';
    }
    if (this.isCampoInvalido(this.fcMensagem)) {
      this.msgMensagem = 'Por favor, informe a Mensagem do e-mail.';
    }
    if (this.isCampoLen(this.fcMensagem)) {
      this.msgMensagem = 'Quantidade de caracteres informado inválido!';
    }

  }


  isCampoInvalido(fc: FormControl): boolean {
    return fc.invalid && fc.errors.required;
  }
  isCampoLen(fc: FormControl): boolean {
    return fc.getError('maxlength');
  }

  /*
  *   Obtém os parâmetros do exercício informado.
  *
  *   anoExercicio: Ano do exercício.
  *   exibirMensagem: Status de exibição do modal com mensagem de aviso ou erro.
  *       O modal será exibido quando o componente estiver no modo de edição.
  *       No modo de consulta não há necessidade.
  */

  getParametrosPagamento(projeto :string) {
    this._service.routePrefix = '/api/ProcessamentoArquivoRetorno/ObterTodos';

    this.aslibLoadingService.start();

    this.subscription = this._service.getAll('gpa')
      .subscribe(res => {
        const parametros: any[] = res;
        this.parametroPagamentoList = res;
        /*
         * Atualiza o formulário com valores retornados da Web.
         */
        this.atualizarFormulario(parametros);

      },
        (error) => {
            this.exibirErro(error);
        },
        () => {
          this.aslibLoadingService.complete();
          if (this.subscription) {
            this.subscription.unsubscribe();
          }
        }
      );
  }


}



// WEBPACK FOOTER //
// ./src/app/parametros/param-notificacao/param-notificacao.component.ts